module.exports = __webpack_public_path__ + "static/media/placeholder-640.c00389e3.svg";